import React from 'react'
import ContentLoader from "react-content-loader";
import '../styles/marketValueSummaryV1.scss'

function MarketValueSummaryV1Loader(){
  return(
      <div className="appraisal-page-container appraisal-page-loading">
      <div className="appraisal-page-loading-desktop">
        <ContentLoader
          uniqueKey="appraisal-loader-desktop"
          width={1000}
          height={900}
          viewBox="0 0 1000 900"
          style={{ width: "100%", height: "auto", display: "block" }}
        >
          {/* --- Value Details section --- */}

          {/* Left “gauge” ring placeholder (approx 250x250) */}
          <circle cx="125" cy="150" r="110" fill="none" stroke="#e9e9e9" strokeWidth="18" />
          {/* center price + subtext */}
          <rect x="55" y="125" rx="6" ry="6" width="140" height="38" />
          <rect x="70" y="170" rx="5" ry="5" width="110" height="16" />
          <rect x="62" y="192" rx="5" ry="5" width="126" height="16" />

          {/* Right breakdown rows (start after 250 + 40 gap = x=290) */}
          {/* Row 1 (Reconditioning “Verified Complete”) */}
          <rect x="290" y="40" rx="6" ry="6" width="670" height="44" />
          {/* icon + label + value layout */}
          <rect x="305" y="54" rx="4" ry="4" width="18" height="18" />
          <rect x="335" y="54" rx="5" ry="5" width="220" height="18" />
          <rect x="840" y="54" rx="5" ry="5" width="120" height="18" />

          {/* Row 2 */}
          <rect x="290" y="92" rx="6" ry="6" width="670" height="44" />
          <rect x="305" y="106" rx="4" ry="4" width="18" height="18" />
          <rect x="335" y="106" rx="5" ry="5" width="200" height="18" />
          <rect x="840" y="106" rx="5" ry="5" width="120" height="18" />

          {/* Row 3 (Market Value with subtext lines) */}
          <rect x="290" y="144" rx="6" ry="6" width="670" height="54" />
          <rect x="305" y="160" rx="4" ry="4" width="18" height="18" />
          <rect x="335" y="160" rx="5" ry="5" width="210" height="18" />
          <rect x="335" y="182" rx="5" ry="5" width="140" height="12" />
          <rect x="840" y="160" rx="5" ry="5" width="120" height="18" />
          <rect x="880" y="182" rx="5" ry="5" width="80" height="12" />

          {/* Row 4 (Dealer Price) */}
          <rect x="290" y="206" rx="6" ry="6" width="670" height="44" />
          <rect x="305" y="220" rx="4" ry="4" width="18" height="18" />
          <rect x="335" y="220" rx="5" ry="5" width="170" height="18" />
          <rect x="840" y="220" rx="5" ry="5" width="120" height="18" />
          <rect x="880" y="242" rx="5" ry="5" width="80" height="12" />

          {/* Row 5 (You Save) */}
          <rect x="290" y="258" rx="6" ry="6" width="670" height="44" />
          <rect x="305" y="272" rx="4" ry="4" width="18" height="18" />
          <rect x="335" y="272" rx="5" ry="5" width="160" height="18" />
          <rect x="840" y="272" rx="5" ry="5" width="120" height="18" />

          {/* --- Comparables section --- */}
          <rect x="0" y="340" rx="6" ry="6" width="700" height="22" /> {/* section title */}
          <rect x="820" y="318" rx="8" ry="8" width="180" height="90" /> {/* right tag box */}

          {/* Table header row */}
          <rect x="0" y="410" rx="6" ry="6" width="1000" height="34" />
          <rect x="20" y="419" rx="4" ry="4" width="90" height="16" />
          <rect x="265" y="419" rx="4" ry="4" width="70" height="16" />
          <rect x="510" y="419" rx="4" ry="4" width="90" height="16" />
          <rect x="860" y="419" rx="4" ry="4" width="90" height="16" />

          {/* Current vehicle row */}
          <rect x="0" y="455" rx="6" ry="6" width="1000" height="54" />
          <rect x="20" y="475" rx="5" ry="5" width="120" height="18" />
          <rect x="265" y="475" rx="5" ry="5" width="120" height="18" />
          <rect x="510" y="475" rx="5" ry="5" width="140" height="18" />
          <rect x="860" y="475" rx="5" ry="5" width="110" height="18" />

          {/* A few comparable rows */}
          {Array.from({ length: 4 }).map((_, i) => {
            const y = 520 + i * 62;
            return (
              <React.Fragment key={i}>
                <rect x="0" y={y} rx="6" ry="6" width="1000" height="54" />
                <rect x="20" y={y + 20} rx="5" ry="5" width="120" height="18" />
                <rect x="265" y={y + 20} rx="5" ry="5" width="120" height="18" />
                <rect x="510" y={y + 20} rx="5" ry="5" width="140" height="18" />
                <rect x="860" y={y + 20} rx="5" ry="5" width="110" height="18" />
              </React.Fragment>
            );
          })}

          {/* Disclaimer lines */}
          <rect x="0" y="800" rx="5" ry="5" width="980" height="14" />
          <rect x="0" y="820" rx="5" ry="5" width="940" height="14" />
          <rect x="0" y="840" rx="5" ry="5" width="900" height="14" />
        </ContentLoader>
    </div>

    <div className="appraisal-page-loading-mobile">
        <ContentLoader
          uniqueKey="appraisal-loader-mobile"
          width="100%"
          viewBox="0 0 375 1100"
          height={1100}
          style={{ width: "100%", display: "block" }}
        >
          {/* mobile skeleton: stacked layout */}
          {/* Top: title lines */}
          <rect x="16" y="16" rx="6" ry="6" width="220" height="18" />
          <rect x="16" y="42" rx="6" ry="6" width="160" height="14" />

          {/* Gauge */}
          <circle cx="187.5" cy="190" r="95" fill="none" stroke="#e9e9e9" strokeWidth="16" />
          <rect x="110" y="170" rx="6" ry="6" width="155" height="30" />
          <rect x="125" y="206" rx="5" ry="5" width="125" height="14" />

          {/* Breakdown rows (full width, stacked) */}
          {Array.from({ length: 5 }).map((_, i) => {
            const y = 310 + i * 56;
            return (
              <React.Fragment key={i}>
                <rect x="16" y={y} rx="8" ry="8" width="343" height="44" />
                <rect x="30" y={y + 13} rx="4" ry="4" width="18" height="18" />
                <rect x="58" y={y + 13} rx="5" ry="5" width="160" height="18" />
                <rect x="265" y={y + 13} rx="5" ry="5" width="90" height="18" />
              </React.Fragment>
            );
          })}

          {/* Comparables header */}
          <rect x="16" y="610" rx="6" ry="6" width="260" height="18" />
          <rect x="16" y="640" rx="10" ry="10" width="343" height="70" />

          {/* Table rows as cards */}
          {Array.from({ length: 4 }).map((_, i) => {
            const y = 730 + i * 78;
            return (
              <React.Fragment key={i}>
                <rect x="16" y={y} rx="10" ry="10" width="343" height="62" />
                <rect x="28" y={y + 14} rx="6" ry="6" width="120" height="14" />
                <rect x="28" y={y + 36} rx="6" ry="6" width="90" height="14" />
                <rect x="220" y={y + 14} rx="6" ry="6" width="120" height="14" />
                <rect x="220" y={y + 36} rx="6" ry="6" width="90" height="14" />
              </React.Fragment>
            );
          })}
        </ContentLoader>
      </div>
    </div>
  )
}

export default MarketValueSummaryV1Loader;
